export function SET_CULTURE_MEDIA_LIST(state, cultureMedia) {
  state.cultureMediaList = cultureMedia;
}
